import * as api from "../Api";

// create a  new asset
export const getDisposedAsset = () => async (dispatch) => {
  try {
    const { data } = await api.getDisposedAsset();
    dispatch({ type: "GET_ALL_DISPOSED", payload: data });
  } catch (error) {}
};

export const disposeAsset = (postData, id) => async (dispatch) => {
  try {
    const { data } = await api.disposeAsset(postData, id);
    dispatch({ type: "DISPOSE_ASSET", payload: data });
  } catch (error) {}
};
